import { MEMBERSHIP_EXTENSION_MODULE } from "@/api_framework/api_config";
import {
  IMembershipExtensionDetailResponse,
  IMembershipExtensionDetailResponseData,
} from "@/api_framework/api_modals/MembershipExtension";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useMembershipExtensionDetailsAPI = () => {
  const [membershipExtensionDetails, setMembershipExtensionDetails] =
    useState<IMembershipExtensionDetailResponseData>(null);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (extension_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${MEMBERSHIP_EXTENSION_MODULE?.MEMBERSHIP_EXTENSION_DETAIL?.baseURL}${extension_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IMembershipExtensionDetailResponse>) => {
            if (res.data.status) {
              setMembershipExtensionDetails(res.data.data);
            } else {
              setMembershipExtensionDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            setMembershipExtensionDetails(null);
            sendCurl(e.config["curlCommand"]);
            captureError(e);
          });
      } catch (e: any) {
        setMembershipExtensionDetails(null);
      }
    },
    [dispatch, configuration],
  );
  return { execute, membershipExtensionDetails };
};
